<template>
  <div
    class="dl-section"
  >
    <Header
        :pageTitle = "navigation.verlag.headerTitle[lang]"
        schema="default"
    />
    <b-container
      class="mb-4"
      v-if="sectionData"
    >
      <Breadcrumb
        :pathToPage="pathToThisPage"
      />
      <b-row
      >
        <b-col
          md="12"
        >
          <h1 class="test-section-data">{{ sectionData.titel }}</h1>
          <div
            v-if="sectionData.kurztext"
            v-html="normalize(sectionData.kurztext)"
            class="lead mb-0"
          />
          <div
            v-if="sectionData.thementext"
            v-html="normalize(sectionData.thementext)"
            class=""
          />
          <!-- <h3
            class="mb-4"
          >
            {{pageContentElements('dlSections').hauptspalteTitel }}
          </h3> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col
          md="7"
        >
          <div
            v-if="sectionData && sectionData.zuordnung"
          >
            <div
              v-for="(abschnitt, index) in sectionData.zuordnung"
              :key="index"
              class="pub-list-section"
            >
              <h4
                class="pub-list-section-title"
              >
                {{ abschnitt.abschnitt }}
              </h4>
              <div
                v-for="(pub, index) in sectionDataPubList"
                :key="index"
                class="pub-list-entry-container"
              >
                <div
                  v-if="pub.zuordnung === abschnitt.abschnitt"
                  class="pub-list-entry mb-4"
                >
                  <div
                    class="pub-list-entry-content"
                  >
                    <p>{{ pub.verfasser }}<br/>
                    <em>{{ pub.kurztitel }}</em></p>
                    <MehrButton
                      :linkTo="`/publikationen/${pub.slug}/${lang}`"
                    />
                  </div>
                  <EditButton
                    contentType="publikationen"
                    :itemId="pub.id"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="(pub, index) in sectionDataPubList"
            :key="index"
            class="pub-list-entry-container"
          >
            <div
              v-if="sectionData && !sectionData.zuordnung"
              class="pub-list-entry mb-4"
            >
              <div
                class="pub-list-entry-content"
              >
                <p>{{ pub.verfasser }}<br/>
                <em>{{ pub.kurztitel }}</em></p>
                <MehrButton
                  :linkTo="`/publikationen/${pub.slug}/${lang}`"
                />
              </div>
              <EditButton
                contentType="publikationen"
                :itemId="pub.id"
              />
            </div>
          </div>
        </b-col>
        <b-col
          md="5"
          class="publist-sidebar"
        >
          <h4
            class="mb-4"
          >
          {{ pageContentElements('dlSections').sidebarTitel }}
          </h4>
          <div
            v-for="(pub, index) in sectionDataFeaturedPubList"
            :key="index"
          >
            <div
              class="featured-pulication mb-4"
            >
              <b-img
                v-if="pub.cover"
                :src="pub.cover" fluid
                class="mb-3"
              />
              <p>{{ pub.verfasser }}<br/>
              <em>{{ pub.kurztitel }}</em></p>
              <MehrButton
                :linkTo="`/publikationen/${pub.slug}/${lang}`"
              />
              <EditButton
                contentType="publikationen"
                :itemId="pub.id"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Header from '@/components/Header.vue'
import EditButton from '@/components/subparts/Edit-button-subpart.vue'
import MehrButton from '@/components/subparts/Mehr-button-subpart.vue'
import Breadcrumb from '@/components/subparts/Breadcrumb-subpart.vue'
import initView from '../mixins/initView'

export default {
  name: 'SektionDBRubriken',
  components: {
    Header,
    EditButton,
    MehrButton,
    Breadcrumb
  },
  mixins: [
    initView
  ],
  methods: {
    ...mapActions([

    ]),
    // checkLoginStatus () {
    //   let boltBE = 'http://dh-north-bolt.culture-to-go.de/bolt/'
    //   axios.get(boltBE, {
    //     // params: {      }
    //   })
    //     .then(response => {
    //     })
    // }
    fetchData () {
      const section = this.$route.params.section
      this.$store.dispatch('fetchApiSingleDLSectionData', section)
    }
  },
  computed: {
    ...mapGetters({
      staticData: 'getStaticData',
      sectionData: 'getDLSectionData',
      sectionDataPubList: 'getDLSectionDataPubList',
      sectionDataFeaturedPubList: 'getDLSectionDataFeaturedPubList',
      lang: 'getLanguage',
      navigation: 'getNavigation',
      pageContentElements: 'getPageContentElements',
      newRoute: 'getNewRoute'
    }),
    pathToThisPage () {
      let path = []
      let nav = this.$store.state.navigation
      let lang = this.lang

      path[0] = {
        name: nav.home.navTitle[lang],
        slug: '/',
        disabled: false
      }
      path[1] = {
        name: nav.verlag.navTitle[lang],
        slug: `/verlag/${lang}`,
        disabled: false
      }
      if (this.$store.getters.getDLSectionData) {
        path[2] = {
          name: this.$store.getters.getDLSectionData.titel,
          slug: '/verlag/' + this.$store.getters.getDLSectionData.slug,
          disabled: true
        }
      } else {
        // fängt lediglich temporäres Fehlen des Objekts im Store ab
        path[2] = path[1]
      }
      return path
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  }
}
</script>

<style scoped lang="scss">

</style>
